<template>
  <div class="row m-0" id="inicio">
    <div class="col-12">
      <h1 class="title font-weight-bold text-uppercase">
        Minha Assinatura
      </h1>

      <hr class="linha-amarela" />
    </div>
    
    <div class="col-12" v-if="response != null">

      <span :class="response.active == true ? 'text-success' : 'text-danger'">
        <b>Conta:</b> {{response.active == true ? 'Ativa' : 'Inativa'}}
      </span>
      <br>
      <span :class="response.active == true ? 'text-success' : 'text-danger'">
        <b>Plano:</b> {{response.plan_name}}
      </span>
      <br>
      <span>
        <b>Vencimento da próxima fatura:</b> {{response.expires_at ? formatarData(response.expires_at) : '-'}}
      </span>

      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-center">Vencimento</th>
            <th class="text-center">Status</th>
            <th class="text-center">Valor</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in response.recent_invoices" :key="i">
            <td class="text-center">{{formatarData(item.due_date)}}</td>
            <td class="text-center">{{formatarStatus(item.status)}}</td>
            <td class="text-center">{{item.total}}</td>
            <td class="text-center">
              <span 
                class="btn btn-primary cursor-pointer"
                title="Realizar pagamento PIX"
                v-if="item.status == 'pending'"
                @click="realizarPagamento(item.id)"
              >
                <i class="fas fa-wallet"></i>
              </span>

              <span 
                class="btn btn-primary cursor-pointer"
                title="Realizar pagamento PIX"
                v-else-if="item.status == 'expired'"
                @click="realizarPagamentoExpirada(item.id)"
              >
                <i class="fas fa-wallet"></i>
              </span>

              <span v-else>
                -
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      title="Pagamento por PIX"
      size="md"
      id="pagamentoPixModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12 text-center">
          <img :src="qr_code" alt="Qr Code">
        </div>

        <div class="col-md-12">
          <textarea class="form-control" rows="4" :value="qrcode_text" readonly></textarea>

          <button class="btn btn-primary btn-block mt-2 mb-2" @click="copyToClipboard()">
            Copiar qr code pix
          </button>
        </div>

        <div class="col-md-12">
          <button class="btn btn-success btn-block" @click="validarPagamento()">
            Já realizei o pagamento!
          </button>
        </div>
      </div>
    </b-modal>
      
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';
import scrollToElement from '../../mixins/scrollToElement';

export default {
  mixins: [scrollToElement],
  name: 'assinatua-iugu',
  data() {
    return {
      response: null,
      qr_code: '',
      qrcode_text: ''
    };
  },
  mixins: [makeToast],
  computed: {
    ...mapState({
      setValidation: (state) => state.setValidation,
    }),
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.showIugu();
  },
  methods: {
    showIugu() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('professional/showInfoAssinatura', this.dadosUsuario.id)
        .then((response) => {
          this.$store.dispatch('endLoader');
          if(response.data != '') {
            this.response = response.data;
          }
        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
        });
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.qrcode_text);
      this.makeToast('Sucesso!', 'Copiado com sucesso!', 'success');
    },
    realizarPagamento(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('professional/showFaturaId', id)
        .then((response) => {
          this.$store.dispatch('endLoader');
          this.qr_code = response.data.pix.qrcode;
          this.qrcode_text = response.data.pix.qrcode_text;

          this.$bvModal.show('pagamentoPixModal');
        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
        });
    },
    realizarPagamentoExpirada(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/expiredFaturaId', id)
        .then((response) => {
          this.$store.dispatch('endLoader');
          this.qr_code = response.data.pix.qrcode;
          this.qrcode_text = response.data.pix.qrcode_text;

          this.$bvModal.show('pagamentoPixModal');
        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
        });
    },
    validarPagamento() {
      this.$bvModal.hide('pagamentoPixModal');
      this.showIugu();
    },
    formatarData(value) {
      var data = new Date(value);

      var dia = data.getDate();
      var mes = data.getMonth() + 1;
      var ano = data.getFullYear();

      var dataFormatada = dia + '/' + mes + '/' + ano;

      return dataFormatada;
    },
    formatarStatus(value) {
      if(value == 'pending') {
        return 'Pendente';
      } else if(value == 'paid') {
        return 'Pago';
      } else if(value == 'canceled') {
        return 'Cancelada';
      } else if(value == 'in_analysis') {
        return 'Em análise';
      } else if(value == 'draft') {
        return 'Rascunho';
      } else if(value == 'partially_paid') {
        return 'Parcialmente paga';
      } else if(value == 'refunded') {
        return 'Reembolsada';
      } else if(value == 'expired') {
        return 'Expirada';
      } else if(value == 'in_protest') {
        return 'Em protesto';
      } else if(value == 'chargeback') {
        return 'Contestada';
      } else if(value == 'externally_paid') {
        return 'Paga externamente';
      }
    }
  },
};
</script>
